'use strict';

export default (API) => ({
    patients: {
        fetchAppointmentsPatients(establishmentId, requestUuid, params) {
            let url = `v3/establishments/${establishmentId}/appointments/${requestUuid}/patients?${new URLSearchParams(params).toString()}`;
            const request = API.http.get(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateProfileUserPatient(profileUserId, patientUuid, params) {
            const url = `/v3/profile/${profileUserId}/patients/${patientUuid}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
    },
});
